import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { trackEventAsync, setUserId } from 'sh-www/utils/datalayer';

import ENV from 'sh-www/config/environment';
import { blockingLocationAssign } from 'sh-www/utils/window';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class LoginController extends Controller {
  @service('error-tracker') errorTracker;

  @service auth;
  @service router;
  @service session;
  @service store;

  async onAuthSuccess() {
    // GA tracking
    setUserId(this, this.session.currentUser.id);
    await trackEventAsync(this, 'login');

    const slug = this.profileSlugToView;
    const location = slug ? `/${slug}` : EMBER_ROUTE_NAMES.START;

    this.router.transitionTo(location);
  }

  @task
  *authenticate(identification, password) {
    try {
      yield this.auth.login(identification, password);

      yield this.onAuthSuccess();
    } catch (e) {
      if (e.status !== 401) {
        this.errorTracker.error(e, this, 'Error authenticating user');
      }

      throw e;
    }
  }

  @task
  *onGoogleSSO(credential) {
    try {
      yield this.auth.loginGoogleJwt(credential);

      yield this.onAuthSuccess();
    } catch (e) {
      if (e.status !== 401) {
        this.errorTracker.error(e, this, 'Error authenticating user');
      }
      throw e;
    }
  }
}

export default LoginController;
